enum PermitRecurrence {
	Undefined = 0,
	Daily = 1,
	Weekly = 2,
	Monthly = 3,
	Yearly = 4
}

export default PermitRecurrence;
